module.exports = __webpack_public_path__ + "assets/media/externalLinks-arrow.de71a745.svg";